function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.613 10C16.2047 10.5632 16.5198 11.2806 16.499 12.0172C16.4782 12.7537 16.123 13.4589 15.5 14",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.726 8C18.9095 9.12647 19.5397 10.5611 19.4981 12.0343C19.4565 13.5075 18.7459 14.9177 17.5 16",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 13.727C4.5 14.4452 5.08224 15.0274 5.80046 15.0274H7.9368C8.01159 15.0279 8.08557 15.0481 8.15446 15.0871C8.22335 15.1261 8.28578 15.183 8.33813 15.2545L10.7914 18.0517C11.3848 18.7284 12.5 18.3087 12.5 17.4086V6.59136C12.5 5.6913 11.3848 5.27157 10.7914 5.94825L8.33813 8.74551C8.28578 8.81702 8.22335 8.87391 8.15446 8.91289C8.08557 8.95186 8.01159 8.97215 7.9368 8.97256H5.80046C5.08224 8.97256 4.5 9.5548 4.5 10.273V13.727Z",
  stroke: "currentColor",
  strokeLinecap: "round"
});

var SvgOriginalVolume = function SvgOriginalVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOriginalVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/original-volume.1a989608.svg";
export { ForwardRef as ReactComponent };